export default "__VITE_ASSET__Dw88L6d$__"